export default {
  "admin-preview": () => import("/opt/atlassian/pipelines/agent/build/layouts/adminPreview.vue").then(m => m.default || m),
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/opt/atlassian/pipelines/agent/build/layouts/empty.vue").then(m => m.default || m)
}